import React, { memo, useEffect, useState } from 'react';
import styles from './devicesLoader.module.scss';
import ListHeader from '../../../shared/components/ListHeader';
import ListNotFound from '../../../shared/components/ListNotFound';
import ListDevices from './subcomponents/ListDevices';
import FilterDevices from '../FilterDevices';
import { useTranslation } from 'react-i18next';
import { defaultLimit, defaultPage } from '../../../app/conf';
import { useCallback } from 'react';

export const defaultFilters = {
    full_assigned: 1,
    limit: defaultLimit,
    page: defaultPage
};

const DevicesLoader = ({
    getDevicesRequest,
    setDeviceSelected,
    setStateDevices,
    devices: { fetching, devices, submitSuccess, total },
    filtersToUseInQuery
}) => {
    const { t } = useTranslation(['home', 'devices']);

    const [page, setPage] = useState(defaultFilters.page);

    const getMoreItems = () => {
        const _page = page + 1;

        setPage(_page);
        getDevicesRequest({
            ...defaultFilters,
            ...filtersToUseInQuery,
            page: _page
        });
    };

    const getDevices = useCallback(() => {
        setStateDevices({ devices: [] });
        setPage(defaultFilters.page);
        getDevicesRequest({ ...defaultFilters, ...filtersToUseInQuery });
    }, [setStateDevices, getDevicesRequest, filtersToUseInQuery]);

    useEffect(() => {
        getDevices();
    }, [getDevices]);

   

    useEffect(() => {
        if (submitSuccess) {
            getDevices();
        }
    }, [submitSuccess, getDevices]);

    useEffect(() => {
        return () => {
            setStateDevices({ devices: [], total: 0, fetching: false });
        };
    }, [setStateDevices]);

    return (
        <>
            <FilterDevices />
            <div className={styles.content}>
                <ListHeader>
                    <div> {t('devices:admission_date')} </div>
                    <div> IMEI </div>
                    <div> {t('devices:provider')} </div>
                    <div> {t('devices:model')} </div>
                    <div> {t('home:status')} </div>
                    <div>  </div>
                    <div className={styles.textAlignCenter}> {t('devices:enabled')} </div>
                    <div className={styles.iconColumn}> </div>
                </ListHeader>
                {(fetching || devices.length > 0) && (
                    <ListDevices
                        devices={devices}
                        fetching={fetching && page === 1}
                        fetchingMoreItems={fetching && page > 1}
                        setDeviceSelected={setDeviceSelected}
                        totalItems={total}
                        onScrollBottomAction={getMoreItems}
                        submitSuccess={submitSuccess}
                    />
                )}

                {!fetching && devices.length === 0 && <ListNotFound />}
            </div>
        </>
    );
};

export default memo(DevicesLoader);
